import React, { useCallback, useEffect, useState } from 'react';
import Grid from '@mui/material/Grid2';
import { OrgDiagram } from 'basicprimitivesreact';
import './orgChart.css'
import {
  PageFitMode,
  Enabled,
  OrientationType,
  ConnectorType,
  LineType,
  Colors
} from 'basicprimitives';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faBriefcase, faEnvelope, faMagnifyingGlass, faPhone, faHandshake, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { useLocation, useNavigate } from 'react-router-dom';
import { Modal, Tab, Tabs } from 'react-bootstrap';
import { apiService } from '../../services/apiService';

function OrgChart() {
    const { search } = useLocation();
    const paramValue = search.replace("?", "");
    const paramId = paramValue ? parseInt(paramValue, 10) : null;

    const navigate = useNavigate();
    const [selectedPerson, setSelectedPerson] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const handleClose = () => setShowModal(false);
    const [loading, setLoading] = useState(false);
    const [loadingMember, setLoadingMember] = useState(false);
    const [treeData, setTreeData] = useState([]);
    const [teamMemData, setTeamMemData] = useState([]);
    const [topManagerData, setTopManagerData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [cursorItem, setCursorItem] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [paginatedata, setPaginateData] = useState({});
    const userId = localStorage.getItem('userid');

    const fetchTabData = useCallback(async (params = {}) => {
        setLoading(true);
        try {
            const response = await apiService.postRequest(`/organizational-chart`, params);
            if(response && response.success){
              setTreeData(response.data);
              // Set the first item as cursor item to center on it
            //   if(response.data && response.data.length > 0) {
            //     const userIdNum = userId ? parseInt(userId, 10) : null;
            //     const userExists = userIdNum && response.data.some(item => item.id === userIdNum);
            //     setCursorItem(userExists ? userIdNum : response.data[0].id);
            //   }
            if (response.data && response.data.length > 0) {
                const firstId = response.data[0].id;
                const isParamValid = paramId && response.data.some(item => item.id === paramId);
                const userIdNum = userId ? parseInt(userId, 10) : null;
                const isUserValid = userIdNum && response.data.some(item => item.id === userIdNum);
                if (isParamValid) {
                setCursorItem(paramId);
                } else if (isUserValid) {
                setCursorItem(userIdNum);
                } else {
                setCursorItem(firstId);
                }
            }
            }else{
                setTreeData([]);
              if(response && response.authenticate === false){
                  await apiService.postRequest('/auth/logout');
                  localStorage.clear();
                  sessionStorage.clear();
                  window.location.href = '/login';
              }
            }
        } catch (error) {
            console.error('Error fetching tab data:', error);
        } finally {
            setLoading(false);
        }
    }, [userId, paramId]);
    const handleSearch = () => {
        fetchTabData({ search: searchQuery });
    };

    useEffect(() => {
        fetchTabData();
    }, [fetchTabData]);


    const fetchMemData = useCallback(async (params = {}) => {
        setLoadingMember(true);
        if(selectedPerson){
        try {
            const response = await apiService.postRequest(`/team-members/${selectedPerson.id}`, params);
            if(response && response.success){
                setTeamMemData(response.data || []);
                setPaginateData(response.meta || {});
            }else{
                setTeamMemData([]);
              if(response && response.authenticate === false){
                  await apiService.postRequest('/auth/logout');
                  localStorage.clear();
                  sessionStorage.clear();
                  window.location.href = '/login';
              }
            }
        } catch (error) {
            console.error('Error fetching tab data:', error);
        } finally {
            setLoadingMember(false);
        }
        }
    }, [selectedPerson]);
    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
        fetchMemData({ page: newPage });
    };

    useEffect(() => {
        fetchMemData();
    }, [fetchMemData]);

    useEffect(() => {
        if (selectedPerson) {
            const fetchData = async () => {
                const response = await apiService.postRequest(`user-top-level-managers/${selectedPerson.id}`);
                if (response.success) {
                    setTopManagerData(response.data?.managers || []);
                }else{
                    setTopManagerData([]);
                }
            };
            fetchData();
        }
    }, [selectedPerson]);

    const templates = [
        {
            name: 'uniformTemplate',
            itemSize: { width: 220, height: 100 },
            minimizedItemSize: { width: 4, height: 4 },
            highlightPadding: { left: 0, top: 0, right: 0, bottom: 0 },
            highlightBorderWidth: 0,
            highlightBorderRadius: 100,
            highlightBackgroundColor: Colors.LightBlue,
            onItemRender: ({ context: itemConfig }) => {
                const { name, job_title, department, profile_picture  } = itemConfig;

                const handleClick = (e) => {
                    setSelectedPerson(itemConfig);
                    setShowModal(true);
                };

                return (
                    <div className='hoverer_pinksets' onClick={handleClick} style={{
                        width: '220px',
                        height: '100px',
                        background: '#ECEDFF',
                        borderRadius: '12px',
                        border: '1px solid #e5e7eb',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                        color: '#374151',
                        padding: '5px 10px',
                        fontFamily: "'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        boxSizing: 'border-box',
                        transition: 'all 0.2s ease',
                        cursor: 'pointer'
                    }}>
                        {profile_picture && profile_picture.length > 0 ?
                            <img style={{
                                width: '56px',
                                height: '56px',
                                borderRadius: '8px',
                                objectFit: 'cover',
                                flexShrink: 0
                            }} src={profile_picture} alt={name}
                            /> :
                            <img style={{
                                width: '56px',
                                height: '56px',
                                borderRadius: '8px',
                                objectFit: 'cover',
                                flexShrink: 0
                            }} src={require("../../assets/org_chart/default_profile.svg").default} alt="default"
                            />
                        }

                        <div className='hoverer_dark_pinksets' style={{
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            overflow: 'hidden',
                            background: "#F5F5F5",
                            padding: "2px 10px",
                            borderRadius: "5px",
                        }}>
                            <div className='chart_tree_title' style={{
                                fontWeight: '600',
                                fontSize: '16px',
                                color: '#1A5298',
                                marginBottom: '2px',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            }}>
                                {name}
                            </div>
                            <div style={{
                                fontSize: '14px',
                                color: '#000',
                                fontWeight: '500',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            }}>
                                {job_title}
                            </div>
                            <div style={{
                                fontSize: '14px',
                                color: '#000',
                                fontWeight: '500',
                                marginTop: '1px',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            }}>
                                {department}
                            </div>
                        </div>
                    </div>
                );
            }
        }
    ];

    const config = {
        items: treeData.map(item => ({
            ...item,
            templateName: 'uniformTemplate'
        })),
        templates,
        cursorItem: cursorItem,
        highlightItem: null,
        pageFitMode: PageFitMode.None,
        orientationType: OrientationType.Top,
        connectorType: ConnectorType.Squared,
        linesWidth: 1.5,
        linesColor: Colors.Gray,
        linesType: LineType.Solid,
        hasSelectorCheckbox: Enabled.False,
        showCallout: Enabled.False,
        hasButtons: Enabled.False,
        highlightGravityRadius: 0,
        enablePanning: Enabled.True,
        minimalVisibility: 0,
        maximumVisibility: 2,
        normalItemsInterval: 30,
        normalLevelShift: 50,
        highlightBorderColor: Colors.Transparent,
        cursorBorderColor: Colors.Transparent,
    };

    return (
        <div className='container-fluid px-0'>
            <div className='content_container'>
                <Grid size={{ xs: 12 }} container className="main_jobseeker">
                    <Grid size={{ md: 12, xs: 12 }} container flexDirection="column" className="jobseekerhead">
                        <h3>Organization chart</h3>
                        <span><b onClick={() => navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> Organization chart</span>
                    </Grid>
                    <Grid size={{ xs: 12 }} container justifyContent="space-between" alignItems="center" className="my-4">
                        <Grid size={{ md: 4, sm: 6, xs: 12 }} container flexDirection="column">
                            <div className='d-flex jobseekersearch my-3'>
                                <div className='col-md-9 input_jobssearch'>
                                    <FontAwesomeIcon className='iconcol' icon={faMagnifyingGlass} />
                                    <input type='text' placeholder='search'
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                handleSearch();
                                            }
                                        }} />
                                </div>
                                <div className='col-md-3 col-4'>
                                    <button onClick={handleSearch}>Search</button>
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                    {loading ?
                        <div className='d-flex justify-content-center w-100'>
                            <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
                        </div> :<>
                        {treeData.length === 0 ? <p className='w-100 text-center'>No Data</p> :
                        <div style={{ 
                            width: '100%', 
                            height: '80vh',
                            position: 'relative',
                            overflow: 'auto'
                        }}>
                            <OrgDiagram
                                centerOnCursor={true}
                                config={config}
                                onHighlightChanging={() => false}
                                onHighlightChanged={() => { }}
                            />
                        </div>
                        }
                        </>
                    }
                </Grid>
            </div>
            <Modal
                show={showModal}
                onHide={handleClose}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body style={{minHeight:"80vh"}}>
                    {selectedPerson && (
                        <div className="row">
                            <div className="modal_widthset_org org_chartmodal text-center mb-3">
                                <div style={{
                                    width: '120px',
                                    height: '120px',
                                    backgroundColor: '#FFEDF7',
                                    borderRadius: '15px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: 'white',
                                    fontSize: '36px',
                                    fontWeight: '600',
                                    padding: '10px'
                                }}>
                                    {selectedPerson.profile_picture && selectedPerson.profile_picture.length > 0 ?
                                        <img style={{
                                            width: '100%',
                                            height: '100%',
                                            borderRadius: '10px',
                                            objectFit: 'cover',
                                            flexShrink: 0
                                        }} src={selectedPerson.profile_picture} alt=""
                                        /> :
                                        <img style={{
                                            width: '100%',
                                            height: '100%',
                                            borderRadius: '10px',
                                            objectFit: 'cover',
                                            flexShrink: 0
                                        }} src={require("../../assets/org_chart/default_profile.svg").default} alt="default"
                                        />
                                    }
                                </div>
                            </div>
                            <div className="main_profilemod_org mb-3 org_chartmodal">
                                <div className="row">
                                    <div className="col-12 ps-0 mb-3">
                                        <h4>{selectedPerson.name}</h4>
                                        {selectedPerson.format_id && 
                                        <p className='d-flex gap-1 align-items-center'><b>Employee ID:</b><h6> {selectedPerson.format_id}</h6></p>
                                        }
                                        {selectedPerson.job_title && 
                                            <p><b>Title: </b>{selectedPerson.job_title}</p>
                                        }
                                        {selectedPerson.department && 
                                            <p><b>Groups: </b>{selectedPerson.department}</p>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className='col-12'>
                                <Tabs defaultActiveKey="overview" className="mt-4 drafttabs_tabs px-0">
                                    <Tab eventKey="overview" title="Overview">
                                        <div className="col-12 p-3 org_chartmodal">
                                            <div className='d-flex flex-column'>
                                                {selectedPerson && selectedPerson.phone_number && selectedPerson.phone_number.length > 0 &&
                                                    <span><FontAwesomeIcon icon={faPhone} className='icon_orgchart' />{selectedPerson.phone_number}</span>
                                                }
                                                {selectedPerson && selectedPerson.email && selectedPerson.email.length > 0 &&
                                                    <span><FontAwesomeIcon icon={faEnvelope} className='icon_orgchart' />{selectedPerson.email}</span>
                                                }
                                                {selectedPerson && selectedPerson.experience_months && selectedPerson.experience_months.length > 0 &&
                                                    <span><FontAwesomeIcon icon={faBriefcase} className='icon_orgchart' />{selectedPerson.experience_months}</span>
                                                }
                                                {selectedPerson && selectedPerson.partnership_status && selectedPerson.partnership_status.length > 0 &&
                                                    <span><FontAwesomeIcon icon={faHandshake} className='icon_orgchart' />{selectedPerson.partnership_status}</span>
                                                }
                                                {selectedPerson && selectedPerson.linkedin_url && selectedPerson.linkedin_url.length > 0 &&
                                                    <a style={{width:"max-content"}} href={`${selectedPerson.linkedin_url}`} target="_blank" rel="noopener noreferrer"><img
                                                        src={require("../../assets/linkedin-logo-blue.svg").default}
                                                        alt="globe"
                                                        style={{width: "30px" , height: "30px" }}
                                                    /></a>
                                                }
                                            </div>
                                        </div>
                                    </Tab>
                                    <Tab eventKey="organization" title="Organization">
                                        <div className="col-12 p-3 height_org_scrollmodal">
                                            <div className='d-flex w-100 flex-column align-items-center'>
                                                {topManagerData && topManagerData.map((datasManager, index)=> (
                                                    <div key={index}  onClick={() => {setSelectedPerson(datasManager);}} className='managers_borderer_org border_afterorgmodal col-xl-5 col-md-6 col-12'>
                                                        <div className='border_tab_profileimg'>
                                                            {datasManager.profile_picture && datasManager.profile_picture.length > 0 ?
                                                                <img src={datasManager.profile_picture} alt=""/> :
                                                                <img src={require("../../assets/org_chart/default_profile.svg").default} alt="default"/>
                                                            }
                                                        </div>
                                                        <div className='main_tabs_cont_org'>
                                                            <h6>{datasManager.name}</h6>
                                                            <span>{datasManager.job_title || "No Title"}</span>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                            <div className='d-flex w-100 flex-wrap align-items-center mt-4'>
                                                {loadingMember ? 
                                                <div className='d-flex justify-content-center w-100'>
                                                    <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
                                                </div> :<>
                                                    {teamMemData.length <= 0 ?
                                                        <p className='w-100 text-center'>No Data</p>  :<>
                                                        <h5 className='w-100 mb-4'>{selectedPerson.name} works with</h5>
                                                        {teamMemData && teamMemData.map((datasMemebers, index)=> (
                                                        <div key={index}  onClick={() => {setSelectedPerson(datasMemebers);}} className='managers_borderer_org col-lg-4 col-md-6 col-12'>
                                                            <div className='border_tab_profileimg'>
                                                                {datasMemebers.profile_picture && datasMemebers.profile_picture.length > 0 ?
                                                                    <img src={datasMemebers.profile_picture} alt=""/> :
                                                                    <img src={require("../../assets/org_chart/default_profile.svg").default} alt="default"/>
                                                                }
                                                            </div>
                                                            <div className='main_tabs_cont_org'>
                                                                <h6>{datasMemebers.name}</h6>
                                                                <span>{datasMemebers.job_title || "No Title"}</span>
                                                            </div>
                                                        </div>
                                                        ))}
                                                        </>
                                                    }
                                                    {paginatedata && paginatedata.last_page !== 1 && (
                                                    <Grid size={{xs:12}} container justifyContent="center" className="mt-4 pagination_btn">
                                                        <button className='arrowpaginate'
                                                            onClick={() => handlePageChange(currentPage - 1)} 
                                                            disabled={currentPage === 1}>
                                                            <FontAwesomeIcon icon={faChevronLeft} />
                                                        </button>
                                                        {paginatedata && (
                                                            <div className="pagination">
                                                                {(() => {
                                                                const totalPages = paginatedata.last_page > 0 ? paginatedata.last_page : 1;
                                                                const pages = [];
                                                                const start = Math.max(2, currentPage - 2);
                                                                const end = Math.min(totalPages - 1, currentPage + 2);
                                    
                                                                // Always show first page
                                                                pages.push(
                                                                    <button
                                                                    key={1}
                                                                    onClick={() => handlePageChange(1)}
                                                                    className={currentPage === 1 ? 'active' : ''}
                                                                    >
                                                                    1
                                                                    </button>
                                                                );
                                    
                                                                if (start > 2) {
                                                                    pages.push(<span key="start-ellipsis">...</span>);
                                                                }
                                    
                                                                for (let i = start; i <= end; i++) {
                                                                    pages.push(
                                                                    <button
                                                                        key={i}
                                                                        onClick={() => handlePageChange(i)}
                                                                        className={currentPage === i ? 'active' : ''}
                                                                    >
                                                                        {i}
                                                                    </button>
                                                                    );
                                                                }
                                    
                                                                if (end < totalPages - 1) {
                                                                    pages.push(<span key="end-ellipsis">...</span>);
                                                                }
                                    
                                                                if (totalPages > 1) {
                                                                    pages.push(
                                                                    <button
                                                                        key={totalPages}
                                                                        onClick={() => handlePageChange(totalPages)}
                                                                        className={currentPage === totalPages ? 'active' : ''}
                                                                    >
                                                                        {totalPages}
                                                                    </button>
                                                                    );
                                                                }
                                    
                                                                return pages;
                                                                })()}
                                                            </div>
                                                            )}
                                    
                                                        <button className='arrowpaginate'
                                                            onClick={() => handlePageChange(currentPage + 1)} 
                                                            disabled={currentPage === paginatedata.last_page}>
                                                            <FontAwesomeIcon icon={faChevronRight} />
                                                        </button>
                                                    </Grid>)}
                                                </>}
                                                
                                            </div>
                                        </div>
                                    </Tab>
                                </Tabs>
                            </div>
                            
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer className='border-0'>
                    <div className="col-12 mt-3">
                        <div className='d-flex justify-content-end pe-5'>
                            <button onClick={handleClose} className='registersendbtn2 my-0'>Close</button>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default OrgChart;